/* eslint-disable @typescript-eslint/no-non-null-assertion */
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import { useTranslation } from 'react-i18next';
import {
  DetailsHeader,
  SvgSingleNeutralBold,
  TextV2,
} from '@insights-ltd/design-library/components';
import { spacingSizeMap } from '@insights-ltd/design-library/themes';
import { LearnerWithEvaluation } from 'api';
import { styled } from '@mui/material';
import { truncatedTextStyles } from './learnerHelper';

const StyledP = styled(TextV2)({
  ...truncatedTextStyles,
});

type LearnerInfoProps = {
  learner: LearnerWithEvaluation;
};
const LearnerInfo = ({ learner }: LearnerInfoProps) => {
  const { t } = useTranslation();

  return (
    <Grid
      container
      spacing={2}
      rowSpacing={1}
      sx={{
        ml: '-0.5rem',
        mr: '-1.5rem',
        mt: '-1rem',
      }}
    >
      <Grid
        container
        sx={(theme) => ({
          mt: theme.spacing(spacingSizeMap.L),
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row',
          '& > path': {
            width: '20px',
            height: '20px',
          },
        })}
        size={12}
      >
        <DetailsHeader
          Icon={SvgSingleNeutralBold}
          text={t('ui.event-management.learner.learner-information')}
          fullWidth
          id="learner-info"
        />
      </Grid>

      <Grid container spacing={2} size={12}>
        <Grid
          container
          size={12}
          sx={{
            justifyContent: 'space-between',
          }}
        >
          <Grid
            sx={{
              pl: 1,
            }}
          >
            <TextV2 variant="bodyBold" color="textSecondary">
              {t('ui.event-management.learner.full-name')}
            </TextV2>
          </Grid>
          <Grid
            sx={{
              pr: 1,
            }}
          >
            <StyledP variant="bodyBold">{learner!.fullName}</StyledP>
          </Grid>
        </Grid>
        <Grid
          container
          size={12}
          sx={{
            justifyContent: 'space-between',
          }}
        >
          <Grid
            sx={{
              pl: 1,
            }}
          >
            <TextV2 variant="bodyBold" color="textSecondary">
              {t('ui.event-management.learner.known-as')}
            </TextV2>
          </Grid>
          <Grid
            sx={{
              pr: 1,
            }}
          >
            <TextV2 variant="bodyBold">{learner!.knownAs}</TextV2>
          </Grid>
        </Grid>
        <Grid
          container
          size={12}
          sx={{
            justifyContent: 'space-between',
          }}
        >
          <Grid
            sx={{
              pl: 1,
            }}
          >
            <TextV2 variant="bodyBold" color="textSecondary">
              {t('ui.event-management.learner.email-address')}
            </TextV2>
          </Grid>
          <Grid
            sx={{
              pr: 1,
            }}
          >
            <TextV2 variant="bodyBold">
              <Link href={`mailto:${learner!.primaryEmail}`}>
                {learner!.primaryEmail}
              </Link>
            </TextV2>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default LearnerInfo;
/* eslint-enable @typescript-eslint/no-non-null-assertion */
